import { Box, Grid2 as Grid, Typography } from "@mui/material";

import { QuicksightDashboard } from "api/memberPortal/reports/quicksight/quicksight.types";

import DashboardCard from "./DashboardCard/DashboardCard";

interface DashboardSectionProps {
  title: string;
  dashboards: QuicksightDashboard[];
}

const DashboardSection = ({ title, dashboards }: DashboardSectionProps) => {
  if (dashboards.length === 0) return;

  return (
    <Box
      sx={{
        paddingY: 4,
        paddingBottom: 1,
        paddingX: 5,
        marginBottom: 3,
      }}
    >
      {/* WARN: Custom styling from pre standardization! */}
      {/* TODO: Standardize when you come across this!  */}
      <Typography
        variant="h1"
        fontSize={30}
        sx={{
          marginBottom: 3,
          textAlign: "left",
          textTransform: "uppercase",
          fontWeight: 700,
        }}
      >
        {title}
      </Typography>

      <Grid container spacing={4}>
        {dashboards.map((dashboard) => (
          <DashboardCard key={dashboard.id} dashboard={dashboard} />
        ))}
      </Grid>
    </Box>
  );
};
export default DashboardSection;
